import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { useScrollRestoration } from "@src/appV2/lib/utils/useScrollRestoration";
import { ListLoadingState } from "@src/appV2/redesign/components/ListLoadingState";
import { PullToRefresh } from "@src/appV2/redesign/ShiftDiscovery/ListView/PullToRefresh";
import { useScrollToTopOnStatusTap } from "@src/appV2/redesign/useScrollToTopOnStatusTap";
import { useRef } from "react";

import { DocumentCardsWrapper } from "../components/DocumentCardsWrapper";
import { DOCUMENTS_LIST_CONTAINER_ID, DOCUMENTS_PAGE_SCROLL_POSITION_KEY } from "./constants";
import { DocumentsPageContentEducationalBanner } from "./EducationalBanner";
import { DocumentsPageMandatoryDocumentsContent } from "./MandatoryDocuments";
import { useDocumentsPageApiContext } from "./useApiProvider";
import { useDocumentsPageNavigationContext } from "./useNavigation";
import { DocumentsPageWorkplaceSpecificDocumentsContent } from "./WorkplaceSpecificDocuments";

export function DocumentsPageContent() {
  const { isLoading, refetch } = useDocumentsPageApiContext();

  const { selectedTab } = useDocumentsPageNavigationContext();

  useScrollRestoration({
    key: DOCUMENTS_PAGE_SCROLL_POSITION_KEY,
    containerId: DOCUMENTS_LIST_CONTAINER_ID,
  });

  const stackRef = useRef<HTMLDivElement>(null);
  useScrollToTopOnStatusTap(stackRef);

  if (isLoading) {
    return <ListLoadingState texts={["Loading documents..."]} wrapperSx={{ grow: 1 }} />;
  }

  return (
    <>
      <PullToRefresh
        scrollRef={stackRef}
        margin={4}
        onRefresh={async () => {
          await refetch();
        }}
      />

      <DocumentCardsWrapper
        ref={stackRef}
        id={DOCUMENTS_LIST_CONTAINER_ID}
        sx={(theme) => ({
          paddingX: 5,
          marginTop: 6,
          ...getSafeAreaPaddings({ bottom: true, fallbackBottom: theme.spacing(5) }),
        })}
      >
        <DocumentsPageContentEducationalBanner />

        {selectedTab === "mandatory" && <DocumentsPageMandatoryDocumentsContent />}
        {selectedTab === "workplaceSpecific" && <DocumentsPageWorkplaceSpecificDocumentsContent />}
      </DocumentCardsWrapper>
    </>
  );
}
